import { useMutation } from 'urql';
import { LOGIN_ADMIN, GET_OAUTH_TOKEN } from './graphql';

export const useLoginAdmin = (query?: any) => {
    const [{ data, fetching, error }, execute] = useMutation((query || LOGIN_ADMIN));
    return { execute, data, fetching, error };
}

export const useGetOAuthToken = () => {
    const [{ data, fetching, error }, execute] = useMutation((GET_OAUTH_TOKEN));
    return { execute, data, fetching, error };
}